import { View, Text, ScrollView, Modal } from "react-native";
import React, { useState } from "react";
import HeaderaPullScreen from "./HeaderaPullScreen";
import BodyaPullScreen from "./BodyaPullScreen";

const APullScreen = ({ pullsData, setShowAPullScreen }) => {
  // const route = useRoute();
  // const pullsData = route.params.item;
  // const newTableData = route.params.newTable;
  // const a_TableData = route.params.a_Table;

  // const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <View>
      <ScrollView>
        <HeaderaPullScreen pullsData={pullsData} setShowAPullScreen={setShowAPullScreen} />

        <BodyaPullScreen pullsData={pullsData} />
      </ScrollView>
    </View>
  );
};

export default APullScreen;
